// @flow
import OveflowedText from './OveflowedText';

export default OveflowedText;
